export var UserTargeting;
(function (UserTargeting) {
    UserTargeting[UserTargeting["All"] = 0] = "All";
    UserTargeting[UserTargeting["New"] = 1] = "New";
    UserTargeting[UserTargeting["Existing"] = 2] = "Existing";
})(UserTargeting || (UserTargeting = {}));
